"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _ascent = _interopRequireDefault(require("../run/ascent"));
/**
 * Returns attributed string ascent
 *
 * @param {Object} attributed string
 * @return {number} ascent
 */


var ascent = function ascent(attributeString) {
  var reducer = function reducer(acc, run) {
    return Math.max(acc, (0, _ascent["default"])(run));
  };

  return attributeString.runs.reduce(reducer, 0);
};

var _default = ascent;
exports["default"] = _default;